import { getServerFieldErrors } from '@/shared/lib';

const FALLBACK = '사이즈 옵션을 저장하지 못했습니다.';

const firstIssueMessage = (message: string): string | null => {
  try {
    const parsed: unknown = JSON.parse(message);
    if (!Array.isArray(parsed)) return null;
    const first: unknown = parsed[0];
    return first &&
      typeof first === 'object' &&
      'message' in first &&
      typeof first.message === 'string'
      ? first.message
      : null;
  } catch {
    return null;
  }
};

/**
 * 사이즈 옵션 저장 오류의 화면 문구 — 입력 검증 오류는 tRPC 가 zod 이슈 배열(JSON)을 message 로 싣는다. 칸 오류의 첫 문구,
 * 없으면 JSON 이슈의 첫 문구, 그것도 아니면 서버 문구를 그대로 보인다(예: '같은 사이즈가 중복되었습니다.').
 */
export const sizeOptionsErrorMessage = (error: unknown): string => {
  const fieldMessage = Object.values(getServerFieldErrors(error) ?? {}).flat()[0];
  if (fieldMessage) return fieldMessage;
  if (!(error instanceof Error) || error.message.length === 0) return FALLBACK;
  return firstIssueMessage(error.message) ?? error.message;
};
